import { render, staticRenderFns } from "./PresentDetail.vue?vue&type=template&id=0da51b91"
import script from "./PresentDetail.vue?vue&type=script&lang=js"
export * from "./PresentDetail.vue?vue&type=script&lang=js"
import style0 from "./PresentDetail.vue?vue&type=style&index=0&id=0da51b91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports